import { render } from "./FormArticolo.vue?vue&type=template&id=3edd4d1f"
import script from "./FormArticolo.vue?vue&type=script&lang=js"
export * from "./FormArticolo.vue?vue&type=script&lang=js"

import "./FormArticolo.vue?vue&type=style&index=0&id=3edd4d1f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__